export const getTranslation = (fallback: string) => {
  return fallback
}

export const TranslateString = (translationId: number, fallback: string) => {
  return fallback
}
